import React from 'react';
import './contact.css';
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";


const Blc_Contact = (props) => {
    const sectionTitle = props.valLoc.find_usTag.split(" ");
    const onsubmitHandler = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
    }

    return (
        <section id='contactPage'>

            <Container>
                <div className="py-3">
                    {/* <h2>{props.valLoc.find_usTag}</h2> */}
                    <h2 className='titles'>
                        <span className='titles-black me-2'>{sectionTitle[0]}</span>
                        <span>{sectionTitle[1]}</span>
                    </h2>
                    <hr style={{ width: '4rem', borderTop: '5px solid #8c8b8b', borderRadius: '10px' }} />
                </div>
                <div>
                    <div className="py-3">
                        <h4 className="mb-3">
                            {props.valLoc.head_office.office_tag}
                        </h4>
                        <p>
                            <b>Phone:</b>  {props.valLoc.head_office.phone} <br />
                            <b>E-mail:</b>  {props.valLoc.head_office.head_officeMail} <br />
                            <b>Address:</b>  {props.valLoc.head_office.head_officeAddress}
                        </p>
                    </div>
                </div>
                <div>
                    <Row md={8} sm={4} xs={1}>
                        {props.valLoc.all_address.map((data, index) =>
                            <Col className="mb-3" lg={3} md={3} sm={3} key={Math.random()}>
                                <Card border="light" style={{ width: '100%', boxShadow: '0 0 18px 0 rgb(83 96 95 / 18%)' }}>

                                    <Card.Header>{data.location_name}</Card.Header>
                                    <Card.Body>
                                        <p style={{ fontSize: '15px' }}>
                                            <b>Address:</b> {data.address}
                                            <br />
                                            <b>Phone:</b> {data.phone}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </div>

            </Container>

            <Container>
                <div className="py-5">
                    {/* <h2>{props.valLoc.get_inTouch}</h2> */}
                    <h2 className="titles">
                        <span className='titles-black me-2'>{props.valLoc.get_inTouch.split(' ')[0]}</span>
                        <span className='titles-black me-2'>{props.valLoc.get_inTouch.split(' ')[1]}</span>
                        <span>{props.valLoc.get_inTouch.split(' ')[2]}</span>
                    </h2>
                    <hr style={{ width: '4rem', borderTop: '5px solid #8c8b8b', borderRadius: '10px' }} />
                </div>
                <div>
                    <Row>
                        <Col className="mb-3">

                            <Form className="form-border" onSubmit={onsubmitHandler}>
                                <Row className="mb-5">
                                    <Form.Group as={Col} controlId="formGridFirstName">
                                        <Form.Control type="name" placeholder="First Name" />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridLastName">
                                        <Form.Control type="name" placeholder="Last Name" />
                                    </Form.Group>
                                </Row>

                                <Row className="mb-5">
                                    <Form.Group as={Col} controlId="formGridPhone">
                                        <Form.Control type="phone" placeholder="Phone" />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridEmail">
                                        <Form.Control type="email" placeholder="E-mail" />
                                    </Form.Group>
                                </Row>

                                <Form.Group className="mb-5" as={Col} controlId="formSubject">
                                    <Form.Control type="subject" placeholder="Subject" />
                                </Form.Group>

                                <Form.Group className="mb-5" controlId="formTextarea">
                                    <Form.Control as="textarea" rows={3} style={{ height: '100px' }} placeholder='Your message...' />
                                </Form.Group>

                                <Button type="submit" className='button-color contact-submit-btn'>
                                    Submit
                                </Button>
                            </Form>
                        </Col>

                        <Col lg={6}>
                            <iframe width="100%" height={450} frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=100%25&height=450&hl=en&q=BRAC%20Centre,%2075%20Mohakhali,%20Dhaka-1212+(BRAC%20Center)&t=p&z=17&ie=UTF8&iwloc=B&output=embed">
                                &lt;a href="https://www.gps.ie/sport-gps/"&gt;bike gps&lt;/a&gt;
                            </iframe>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
};
export default Blc_Contact